import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedGraphApp from "./EmbeddedGraphApp";
const GraphApp = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "Microsoft Graph Input" }, /* @__PURE__ */ React.createElement("span", null, "This input retrieves log records using Microsoft Graph API.")), /* @__PURE__ */ React.createElement(EmbeddedGraphApp, null));
export default GraphApp;
